var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectField',{attrs:{"valueKey":"id","attrs":_vm.attrs,"value":_vm.value,"vueSelect":Object.assign({}, _vm.vueSelect,
    {label: 'name',
    options: _vm.options}),"vueSelectOn":{ search: _vm.fetchOptions }},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }